import { ClaimCoverageEnum } from '../enums/ClaimCoverage.enum';
import { ClaimCoverageOption } from '../types/ClaimCoverageTypes';

export const claimCoverageLabels: Record<ClaimCoverageEnum, string> = {
  [ClaimCoverageEnum.APARTAMENTO_HABITUAL_VERANEIO]: 'Apartamento – Habitual ou veraneio',
  [ClaimCoverageEnum.CASA_HABITUAL_VERANEIO]: 'Casa Habitual ou veraneio',
  [ClaimCoverageEnum.PREDIO_CONTEUDO_PREDIO_MAIS_CONTEUDO]:
    'Prédio / Conteúdo / Prédio + Conteúdo',
  [ClaimCoverageEnum.INCENDIO_RAIO_EXPLOSAO_FUMACA_QUEDA_AERONAVE]:
    'Incêndio / Raio / Explosão/ Fumaça / Queda Aeronave',
  [ClaimCoverageEnum.DANOS_ELETRICOS]: 'Danos Elétricos',
  [ClaimCoverageEnum.RC_FAMILIAR]: 'RC Familiar',
  [ClaimCoverageEnum.VENDAVAL_FURACAO_CICLONE_TORNADO_GRANIZO]:
    'Vendaval, Furacão, Ciclone, Tornado e Granizo',
  [ClaimCoverageEnum.PERDA_PAGAMENTO_ALUGUEL]: 'Perda e Pagamento de Aluguel',
  [ClaimCoverageEnum.ROUBO_FURTO_QUALIFICADO_BENS]: 'Roubo/Furto Qualif. de Bens',
  [ClaimCoverageEnum.QUEBRA_VIDROS_MARMORE_GRANITO]:
    'Quebra de Vidros / Mármores / Granitos',
  [ClaimCoverageEnum.IMPACTO_VEICULOS]: 'Impacto de Veículos',
  [ClaimCoverageEnum.DESMORONAMENTO]: 'Desmoronamento',
  [ClaimCoverageEnum.DESPESAS_EXTRAORDINARIAS]: 'Despesas Extraordinárias',
  [ClaimCoverageEnum.EQUIPAMENTOS_ELETRONICOS]: 'Equipamentos Eletrônicos',
  [ClaimCoverageEnum.ROUBO_FURTO_QUALIFICADO_BENS_FORA_LOCAL_SEGURADO]:
    'Roubo/furto Qualif. De bens fora local segurado',
  [ClaimCoverageEnum.RUPTURA_TANQUES_TUBULACOES]: 'Ruptura de Tanques e Tubulações',
  [ClaimCoverageEnum.TUMULTOS_GREVES_LOCKOUTS]: 'Tumultos, greves e lockouts',
  [ClaimCoverageEnum.ALAGAMENTO]: 'Alagamento'
};

export const claimCoverageOptions: ClaimCoverageOption[] = [
  ClaimCoverageEnum.APARTAMENTO_HABITUAL_VERANEIO,
  ClaimCoverageEnum.CASA_HABITUAL_VERANEIO,
  ClaimCoverageEnum.PREDIO_CONTEUDO_PREDIO_MAIS_CONTEUDO,
  ClaimCoverageEnum.INCENDIO_RAIO_EXPLOSAO_FUMACA_QUEDA_AERONAVE,
  ClaimCoverageEnum.DANOS_ELETRICOS,
  ClaimCoverageEnum.RC_FAMILIAR,
  ClaimCoverageEnum.VENDAVAL_FURACAO_CICLONE_TORNADO_GRANIZO,
  ClaimCoverageEnum.PERDA_PAGAMENTO_ALUGUEL,
  ClaimCoverageEnum.ROUBO_FURTO_QUALIFICADO_BENS,
  ClaimCoverageEnum.QUEBRA_VIDROS_MARMORE_GRANITO,
  ClaimCoverageEnum.IMPACTO_VEICULOS,
  ClaimCoverageEnum.DESMORONAMENTO,
  ClaimCoverageEnum.DESPESAS_EXTRAORDINARIAS,
  ClaimCoverageEnum.EQUIPAMENTOS_ELETRONICOS,
  ClaimCoverageEnum.ROUBO_FURTO_QUALIFICADO_BENS_FORA_LOCAL_SEGURADO,
  ClaimCoverageEnum.RUPTURA_TANQUES_TUBULACOES,
  ClaimCoverageEnum.TUMULTOS_GREVES_LOCKOUTS,
  ClaimCoverageEnum.ALAGAMENTO
].map(value => ({
  value,
  label: claimCoverageLabels[value]
}));
